"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupContainer = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_2 = require("react");
var shortcut_1 = require("../utils/shortcut");
var image_1 = require("./image");
function PopupContainer(props) {
    var children = props.children, open = props.open, close = props.close;
    var popupBackground = (0, react_2.useRef)(null);
    (0, shortcut_1.useShortCut)({
        shortCut: "Escape",
        handler: function () {
            if (popupBackground.current) {
                close && close();
                popupBackground.current.style.display = "none";
            }
        },
    });
    return (react_1.default.createElement("div", { ref: popupBackground, className: (0, clsx_1.default)("fixed left-0 top-0 z-[105] h-screen w-screen bg-color-popup", "flex desktop:items-center desktop:justify-center"), style: {
            display: open ? "flex" : "none",
        }, onClick: function (e) {
            if (e.currentTarget) {
                if (e.currentTarget === popupBackground.current) {
                    if (popupBackground.current) {
                        popupBackground.current.style.display = "none";
                        close && close();
                    }
                }
            }
        } },
        react_1.default.createElement("div", { onClick: function (e) { return e.stopPropagation(); }, className: "flex desktop:relative" },
            children,
            react_1.default.createElement("button", { onClick: function () {
                    if (popupBackground.current) {
                        popupBackground.current.style.display = "none";
                        close && close();
                    }
                }, className: (0, clsx_1.default)("absolute right-[-40px] top-0 hidden bg-color-surface desktop:flex", "h-[32px] w-[32px] items-center justify-center rounded-full", "border border-color-separator") },
                react_1.default.createElement(image_1.CustomThemedResource, { format: "svg", source: "/general/close" })))));
}
exports.PopupContainer = PopupContainer;
//# sourceMappingURL=popup.js.map